import { View, Text } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import RenderClauses from "../constants/renderClauses";
import { formatSerialNumber, numberClauseTree } from "../constants/serialNumbers";
import { getSupervisionFeeSummary } from "../../contractDetails/contractDetailsDefaults";

const ConductOfBusiness = ({ contractDetails = {}, serialNumber = 11 }) => {
  const styles = ContractStyles();
  const supervisionSummary = getSupervisionFeeSummary(
    contractDetails.supervisionFees || {},
  );

  const supervisionFeeClause = (
    <>
      <Text style={styles.text_red}>{supervisionSummary.text}</Text>
      {
        " The Company reserves the right to charge a higher fee where it reasonably deems increased levels of supervision are necessary, or where you undertake business that is higher risk than normal regulated business, due to the increased PI costs this will incur in future years."
      }
    </>
  );

  const obligations = [
    {
      title: "Submitting Business",
      content:
        "The Appointed Representative must use the prescribed electronic sales process to conduct the business with the Company. The Company will only process plan applications and pay commission on business submitted using the electronic sales process. ",
    },
    {
      title: "Performance & Persistency",
      content: "",
      clauses: [
        {
          content:
            "The Appointed Representative will be expected to achieve acceptable standards in accordance with the Company’s advice standards and compliance policies, consumer duty outcomes, and persistency targets as defined by the Company and monitored by the Company’s Field Supervisors and Compliance Team.",
        },
        {
          content:
            "The quality of sales, performance and persistency will be monitored during performance reviews that will be conducted regularly by Company’s Competency Development Managers, Field Supervisors and Business Assurance.",
        },
        {
          content:
            "This Contract may be terminated should the Appointed Representative fail to consistently achieve these minimum performance levels.",
        },
      ],
    },
    {
      title: "Supervision Fee",
      content:
        "A Supervision Fee is payable to maintain this Contract with the Company. This fee is reviewed annually and covers IT Software, supervision and the Professional Indemnity Arrangement.",
      clauses: [
        {
          content: supervisionFeeClause,
        },
        {
          content:
            "An additional £100 per month will be charged for non-industry professionals until they achieve competent adviser status.",
        },
      ],
    },
  ];

  return (
    <View style={[styles.flexColumn, styles.gap_sm]} break>
      <ContractListItem
        id="conduct-of-business"
        marker={formatSerialNumber(serialNumber)}
        markerWidth={0}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        SCHEDULE ONE – Conduct of Business
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm]}>
        {numberClauseTree(obligations, serialNumber).map(({ number, title, content, clauses }) => (
          <View
            key={number}
            style={[
              styles.flexColumn,
              styles.gap_xs,
              // { paddingTop: number === "4.5." ? styles.py_lg : styles.py_md },
            ]}
          >
            <ContractListItem
              marker={number}
              markerWidth={24}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              {title}
            </ContractListItem>
            {content && (
              <ContractListItem
                marker=""
                markerWidth={0}
                styles={styles}
                textStyle={styles.buttonTextSmall}
              >
                {content}
              </ContractListItem>
            )}

            <RenderClauses clauses={clauses} styles={styles} number={number} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default ConductOfBusiness;
